import React from 'react';

import cx from 'classnames';
import { Field, Form } from 'react-final-form';

import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import FormErrorText from 'components/shared/FormErrorText';
import Loader from 'components/shared/Loader';
import AuthTitle from 'components/shared/Typography/AuthTitle';
import useValidationSchema from 'hooks/useValidationSchema';

import AuthLabel from '../../../GuestPortal/Auth/components';
import { useVerificationPage } from './functions';
import style from './index.module.css';
import { validationSchema } from './validationSchema';

function VerificationPage() {
  const { initialValues, showPass, handleSubmit, checkAcc, error, isSuccess, verifying } = useVerificationPage();
  const validate = useValidationSchema(validationSchema);

  if (checkAcc.isLoading || verifying) {
    return <Loader />;
  }

  if (error) {
    return <div className={cx(style.message, style['message-error'])}>{error}</div>;
  }

  if (isSuccess) {
    return <div className={style.message}>Account has been verified successfully</div>;
  }

  return (
    <div>
      {showPass && (
        <Form onSubmit={handleSubmit} validate={validate} initialValues={initialValues}>
          {({ handleSubmit, submitting, hasValidationErrors, submitError }) => {
            return (
              <form onSubmit={handleSubmit} autoComplete="off">
                {/*@ts-ignore*/}
                <AuthTitle>Set password to get started</AuthTitle>

                <AuthLabel>Set Password</AuthLabel>
                <Field
                  component={FormGroupAdapter}
                  name="password"
                  placeholder="Password"
                  type="password"
                  withIcon
                  autoComplete="new-password"
                  withPasswordRequirementsTip
                />

                <AuthLabel>Confirm Password</AuthLabel>
                <Field
                  component={FormGroupAdapter}
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  type="password"
                  withIcon
                  noMargin
                  autoComplete="new-password"
                />

                <Field component="input" name="key" type="hidden" />

                {<FormErrorText>{submitError}</FormErrorText>}

                <FormActions isRight>
                  <Button htmlType="submit" disabled={submitting || hasValidationErrors}>
                    Submit
                  </Button>
                </FormActions>
              </form>
            );
          }}
        </Form>
      )}
    </div>
  );
}

export default VerificationPage;
